import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Select, Button } from 'antd';
import {
  updateQuestionnaireAction,
  getQuestionnairesAction,
} from '../../../../../store/actions/questionnaire.action';

const { Option } = Select;
const { TextArea } = Input;

const EditQuestionnaire = ({ isOpen, setIsOpen, filterValue }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [questionsText, setQuestionsText] = useState('');
  const { questionnaireItem } = useSelector(
    (state) => state?.questionnaireState
  );
  const { getAllConditionsList } = useSelector(
    (state) => state?.conditionState
  );

  useEffect(() => {
    if (questionnaireItem && isOpen) {
      form.setFieldsValue({
        condition_id: questionnaireItem.condition_id,
        questions: questionnaireItem.questions,
      });

      setQuestionsText(questionnaireItem.questions);
    }
  }, [questionnaireItem, isOpen, form]);

  const handleClose = () => {
    form.resetFields();
    setQuestionsText('');
    setIsOpen(false);
  };

  const handleSubmit = (values) => {
    const payload = {
      condition_id: values.condition_id,
      questions: questionsText.trim(),
    };

    dispatch(
      updateQuestionnaireAction(
        questionnaireItem.questionnaire_id,
        payload,
        () => {
          handleClose();
          dispatch(getQuestionnairesAction(filterValue.condition_id));
        }
      )
    );
  };

  return (
    <Modal
      title="Edit Questionnaire"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={1000}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="condition_id"
          label="Condition"
          rules={[{ required: true, message: 'Please select a condition' }]}
        >
          <Select placeholder="Select condition">
            {getAllConditionsList?.map((condition) => (
              <Option
                key={condition.condition_id}
                value={condition.condition_id}
              >
                {condition.condition_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="questions"
          label="Questions"
          rules={[{ required: true, message: 'Please enter questions' }]}
        >
          <TextArea
            value={questionsText}
            onChange={(e) => setQuestionsText(e.target.value)}
            placeholder="Enter all your questions here"
            autoSize={{ minRows: 5, maxRows: 15 }}
            className="w-full"
          />
        </Form.Item>

        <div className="flex justify-end">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditQuestionnaire;
